export function convertDate(timestamp) {
  const d = new Date(timestamp * 1000),
    // Convert the passed timestamp to milliseconds
    yyyy = d.getUTCFullYear(),
    mm = d.getUTCMonth() + 1, // Months are zero based.
    dd = d.getUTCDate();
    
    let date, m = `${mm}`, ddd = `${dd}`;

  if (mm < 10) {
    m = `0${mm}`;
  }
  if (dd < 10) {
    ddd = `0${dd}`;
  }
  // ie: 21/02/2019
  date = `${ddd}/${m}/${yyyy}`;
  return date;
}

export default function happroxy(timestamp, blog = false) {
  const base = { hour: 3600, minute: 60, day: 86400 };
  const timeNow = new Date().getTime() / 1000;
  const margin = timeNow - timestamp;

  let time = margin / base.hour;
  let result;

  if (time < 1) {
    let minutes = margin / base.minute;
    result = `${minutes} min ago`;
    if (minutes <= 0) {
      result = blog ? 'Now' : `Just now`;
    }
    if (minutes === 1) {
      result = blog ? '1 minute ago' : `1 min ago`;
    }
    if (Number.isInteger(minutes) === false) {
      minutes = Math.round(minutes);
      result = blog ? `${minutes} minutes ago` : `${minutes} min ago`;
      if (minutes === 1) {
        result = blog ? '1 minute ago' : `1 min ago`;
      }
      if (minutes <= 0) {
        result = blog ? 'Now' : `Just now`;
      }
    }
  }

  if (time < 24 && time >= 1) {
    result = blog ? `${time} hours ago` : `${time} hr ago`;
    if (time === 1) {
      result = blog ? '1 hour ago' : `1 hr ago`;
    }
    if (Number.isInteger(time) === false) {
      time = Math.round(time);
      result = blog ? `${time} hours ago` : `${time} hr ago`;
      if (time === 1) {
        result = blog ? '1 hour ago' : `1 hr ago`;
      }
    }
  }

  if (time >= 24) {
    const days = margin / base.day;
    if (days >= 1 && days < 2) {
      result = `Yesterday`;
    }
    if (days >= 2 && days < 3) {
      result = blog ? '2 days ago' : `2d ago`;
    }
    if (days >= 3 && days < 4) {
      result = blog ? '3 days ago' : `3d ago`;
    }
    if (days >= 4 && days < 5) {
      result = blog ? '4 days ago' : `4d ago`;
    }
    if (days >= 5 && days < 6) {
      result = blog ? '5 days ago' : `5d ago`;
    }
    if (days >= 6 && days < 7) {
      result = blog ? '6 days ago' : `6d ago`;
    }
    if (days >= 7) {
      result = convertDate(timestamp);
    }
  }
  return result;
}
